const PICKS = [
  {
    tag: "复盘",
    title: "三年前的旧瓜，今天为什么又被翻了出来",
    excerpt: "从人物专题联动到事件查询，我们梳理了这场考古潮的完整引爆路径。",
    read: "阅读 6 分钟",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20an%20old%20magazine%20archives%20and%20yellowed%20newspaper%20clippings%20on%20a%20desk%20with%20warm%20desk%20lamp%20light%2C%20cinematic%20film%20grain%2C%20nostalgic%20amber%20tone%2C%20documentary%20storytelling%20magazine%20feature%20aesthetic&width=1100&height=560&seq=pick-replay-01&orientation=landscape",
  },
  {
    tag: "人物番外",
    title: "从爆红到翻车：一个人物专题的完整记",
    excerpt: "网曝网关键词库里最长的一条人物时间线，我们把它拆成了六个阶段。",
    read: "阅读 8 分钟",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20film%20editing%20timeline%20on%20a%20dark%20screen%20with%20warm%20red%20and%20amber%20glow%20in%20a%20dim%20room%2C%20cinematic%20film%20grain%2C%20documentary%20investigation%20mood%2C%20high%20detail%20editorial%20feature&width=1100&height=560&seq=pick-figure-02&orientation=landscape",
  },
  {
    tag: "考古指南",
    title: "事件查询搜不到？手把手教你用对关键词",
    excerpt: "站内查找高阶技巧，让每一段藏起来的瓜都无所遁形。",
    read: "阅读 4 分钟",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20search%20magnifier%20over%20a%20stack%20of%20night%20city%20newspaper%20pages%20under%20warm%20amber%20streetlight%2C%20cinematic%20film%20grain%2C%20curiosity%20and%20discovery%2C%20magazine%20feature%20aesthetic&width=1100&height=560&seq=pick-guide-03&orientation=landscape",
  },
];

export default function MoreGrid() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-2 text-sm font-semibold text-red-700">
            <span className="h-px w-8 bg-red-700"></span>
            网曝网专题精选
          </div>
          <h2 className="font-serif-sc mt-3 text-balance text-2xl font-black text-stone-900 md:text-3xl">
            本刊编辑部，为你挑好了这几篇
          </h2>
        </div>
        <a href="#events" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-stone-500 hover:text-red-700">
          逛完全部专题
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </a>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {PICKS.map((p) => (
          <article key={p.title} className="paper-card group overflow-hidden rounded-lg">
            <div className="relative overflow-hidden">
              <img
                src={p.image}
                alt={`${p.title} 网曝网专题文章封面`}
                title={`${p.title} 网曝网专题`}
                className="h-52 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-sm bg-[#f7f3eb]/92 px-2 py-0.5 text-[11px] font-semibold text-red-700">
                {p.tag}
              </span>
            </div>
            <div className="p-5">
              <h3 className="font-serif-sc text-base font-bold leading-snug text-stone-900 transition-colors group-hover:text-red-700">
                {p.title}
              </h3>
              <p className="mt-2 text-xs leading-5 text-stone-500">{p.excerpt}</p>
              <div className="mt-4 flex items-center justify-between border-t border-stone-100 pt-3">
                <span className="flex items-center gap-1 text-[11px] text-stone-400">
                  <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                  {p.read}
                </span>
                <span className="inline-flex items-center gap-1 text-[11px] font-medium text-red-700">
                  继续阅读
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}